import React from 'react';
import PropTypes from 'prop-types';
import AudioButton from 'library/components/audio-button';
const KEYS_WITH_FULL_AUDIO = ['english', 'spanish']
const LANGUAGE_MAP = {
    'english': 'en',
    'spanish': 'es'
}

const Checkbox = ({ onClick, active, disabled, type }) => (
    <div className={`adjective-checkbox`}>
        <span onClick={onClick} className={`adjective-checkbox-checkbox ${active ? 'checked' : ''}`}>
            { active ? <i className="icon-ok" /> : null }
        </span>
    </div>
)

export default class AdjectiveRow extends React.PureComponent {
    static defaultProps = {
        active: {}
    }

    constructor(...params) {
        super(...params);

        this.state = {
            definition: false
        }
    }

    toggleReal = () => {
        const { toggleActive, active, adjective } = this.props;
        toggleActive(adjective.id, 'real');
    }

    toggleIdeal = () => {
        const { toggleActive, active, adjective } = this.props;
        toggleActive(adjective.id, 'ideal');
    }

    toggleDefinition = () => {
        this.setState({
            definition: !this.state.definition
        })
    }

    renderAudio = (adjective, language) => (
        KEYS_WITH_FULL_AUDIO.indexOf(language) > -1
            ? <div className="adjective-audio">
                 <AudioButton src={`https://s3.amazonaws.com/pairin-production/assets/audio/${LANGUAGE_MAP[language]}/${adjective.audio_key}`} component="span"><i className="icon-audio" /></AudioButton>
              </div>
            : null
    )

    render() {
        const { adjective, real, ideal, mode, language } = this.props;

        const className = [
            'adjective-drawer',
            this.state.definition ? 'active' : null
        ].filter(c=>c).join(' ')

        return (
            <div className="adjective-row">
                <Checkbox onClick={this.toggleReal} active={real} />
                <div className={className}>
                    <div onClick={this.toggleDefinition} className="adjective-drawer-header">
                        { this.renderAudio(adjective, language) }
                        <div className="adjective-name">
                            { adjective.name[language] }
                        </div>
                        <div className="adjective-toggle">
                            <i className={`icon-angle-${this.state.definition ? 'up' : 'down'}`} />
                        </div>
                    </div>
                    <div className="adjective-definition">
                        { adjective.definition[language] }
                    </div>
                </div>
                { mode === 'ideal'
                    ? <Checkbox onClick={this.toggleIdeal} active={ideal} />
                    : null
                }
            </div>
        )
    }
}
